export default __webpack_public_path__ + "static/media/bihorel8.feee7b17.jpg";